import {Injectable} from '@angular/core';
import {MatomoInitializerService, MatomoTracker} from 'ngx-matomo-client';
import {UiConfigService} from '@lv1871/core';
import {KeycloakLv1871Service} from '@lv1871/core';
import {RuntimeContext} from '@lv1871/core';
import {EventService} from './event.service';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  private _existingMatomoInstance: boolean;

  constructor(private _matomoTracker: MatomoTracker,
              private readonly _matomoInitializer: MatomoInitializerService,
              private readonly _config: UiConfigService,
              private readonly _keycloakService: KeycloakLv1871Service,
              private readonly _eventService: EventService
  ) {
    this.init();

    this._eventService.consent$.subscribe((consent) => {
      this._matomoTracker?.forgetConsentGiven();
      if (consent.matomo) {
        this._matomoTracker?.setConsentGiven();
      } else {
        this._matomoTracker?.forgetConsentGiven();
      }
    });

    this._keycloakService.isAuthenticated$().subscribe(isAuthenticated => {
      if (isAuthenticated) {
        this._matomoTracker?.setCustomDimension(1, UserType.ANGEMELDET.valueOf());
      } else {
        this._matomoTracker?.setCustomDimension(1, UserType.ANONYM.valueOf());
      }
    });

    this._eventService.urlParams$.subscribe(urlParams => {
      this._matomoTracker?.setCustomDimension(2, urlParams.produktId);
    });
  }

  public init() {
    this._existingMatomoInstance = false;

    if (this._keycloakService.getParameter().runtimeContext === RuntimeContext.ANGULAR_SHELL) {
      if(((window as any)?.Matomo)) {
        this._existingMatomoInstance = true;
        this._matomoTracker = (window as any).Matomo.getTracker(this._config.getMatomoConfig().matomo_serverUrl, this._getSiteId());
      }
    }


  }

  public suche(suchbegriff: string, kategorie?: string, resultCount?: number): void {
    if (this._existingMatomoInstance) {
      this._matomoTracker?.trackSiteSearch(suchbegriff, kategorie || 'default', resultCount);
    }
  }

  public trackLink(url: string, linkType: 'link' | 'download' = 'link'): void {
    if (this._existingMatomoInstance) {
      this._matomoTracker?.trackLink(url, linkType);
    }
  }

  public trackEvent(category: string, action: string, name?: string, value?: number): void {
    if (this._existingMatomoInstance) {
      this._matomoTracker?.trackEvent(category, action, name, value);
    }
  }

  public async getVisitorId(): Promise<string> {
    return this._matomoTracker?.getVisitorId();
  }

  private _getSiteId(): number {
    return this._keycloakService.getParameter().internalRequest+'' === 'true' ? this._config.getMatomoConfig().siteId_LAN :
        this._config.getMatomoConfig().siteId_DMZ;
  }

}

export enum UserType {
  ANONYM = 'ANONYM',
  ANGEMELDET = 'ANGEMELDET'
}
